import { Ordenacao } from '../shared/ordenavel/ordenavel.component';
import { normalizarTexto } from './normalizar-texto';

/**
 * Ordenação em memória, para as listagens que **não** são paginadas pela API — aquelas em
 * que o endpoint devolve a coleção inteira. `TAB-01` só autoriza ordenar em memória nesse
 * caso; onde há paginação, ordenar a página carregada mentiria sobre o total.
 *
 * Texto compara sem acento e sem caixa (`FRM-03`), senão "Ângela" cai depois de "Zilda".
 * Número e booleano comparam pelo valor. Ausente vai sempre para o fim, nas duas direções:
 * quem ordena quer ver o que **tem** primeiro.
 */
export function ordenarEmMemoria<T>(
  itens: readonly T[],
  ordenacao: Ordenacao | null,
  valorDe: (item: T, campo: string) => unknown,
): T[] {
  const lista = [...itens];
  if (!ordenacao) {
    return lista;
  }

  const sinal = ordenacao.direcao === 'asc' ? 1 : -1;

  return lista.sort((a, b) => {
    const va = valorDe(a, ordenacao.campo);
    const vb = valorDe(b, ordenacao.campo);

    const aVazio = va === null || va === undefined || va === '';
    const bVazio = vb === null || vb === undefined || vb === '';
    if (aVazio && bVazio) return 0;
    if (aVazio) return 1;
    if (bVazio) return -1;

    if (typeof va === 'number' && typeof vb === 'number') {
      return (va - vb) * sinal;
    }
    if (typeof va === 'boolean' && typeof vb === 'boolean') {
      return (Number(va) - Number(vb)) * sinal;
    }
    return normalizarTexto(String(va)).localeCompare(normalizarTexto(String(vb))) * sinal;
  });
}
